export default {
  short_description: 'Säästä aikaa ja ansaitse palkintoja!',
  full_description:
    '{{name}}-sovellus on nyt saatavilla – entistä helpompaa tilaamista varten:\n\n• Erittäin nopea tilaaminen sovelluksen kautta\n\n• Välittömät ilmoitukset tarjouksista ja palkinnoista\n\n• Kerää ja lunasta pisteesi helposti\n\n• Seuraa tilauksesi tilaa reaaliajassa\n\nTarjoamme mielellämme sinulle sovelluksemme – toivottavasti nautit siitä yhtä paljon kuin me!`',
};
